import { useQuery } from '@tanstack/react-query'

import { getAllBookingInsurancesQuote } from '@flecto/api/saas'
import { type CoreBookingProduct, type ParameterID } from '@flecto/types'
import { isValidParameterID } from '@flecto/utils'

type QueryPayload = {
  bookingId?: ParameterID
  bookingItems?: CoreBookingProduct[]
  enabled?: boolean
  quantityField?: 'quantity' | 'picked_up_quantity'
  at_pickup?: boolean
  end_at?: string
}

export function useQueryGetAllBookingInsurancesQuote({
  bookingId,
  bookingItems,
  quantityField = 'quantity',
  enabled,
  at_pickup = false,
  end_at,
}: QueryPayload) {
  return useQuery({
    queryKey: [
      'QueryGetAllBookingInsurancesQuotes',
      Number(bookingId),
      bookingItems,
    ],
    queryFn: async () => {
      const products = bookingItems?.map((product) => {
        const productToCheck = {
          id: product.id,
          quantity:
            quantityField === 'quantity'
              ? product.quantity
              : product.picked_up_quantity +
                product.local_old_picked_up_quantity,
        }

        return productToCheck
      })

      return await getAllBookingInsurancesQuote(bookingId ?? '', {
        booking_items: products,
        at_pickup,
        end_at,
      })
    },
    enabled:
      typeof enabled === 'boolean' ? enabled : isValidParameterID(bookingId),
  })
}
